import { Close } from "@carbon/icons-react";
import { t } from "i18next";
import { useState } from "react";

import PageLoader from "../../../../components/PageLoader";
import FallbackComponent from "../../../../components/fallbackComponent/FallbackComponent";
import { useOrderContext } from "../../../../contexts/OrderContext";
import { useNewOrderQueryData } from "../../../../hooks/useNewOrderQueryData";
import { objectsHaveEqualValues } from "../../../../utils/helper";
import LeaveNewOrderAlertDialog from "../../components/leaveNewOrderAlertDialog/LeaveNewOrderAlertDialog";
import ConfirmationScreen from "../confirmationScreen/ConfirmationScreen";
import DeliveryItemsScreen from "../deliveryItemsScreen/DeliveryItemsScreen";
import DocumentItemsScreen from "../documentItemsScreen/DocumentItemsScreen";
import EnterTimesScreen from "../enterTimesScreen/EnterTimesScreen";
import GeneralInfoScreen from "../generalInfoScreen/GeneralInfoScreen";
import SummaryScreen from "../summaryScreen/SummaryScreen";
import "./ProgressContent.scss";

interface ProgressContentProps {}

const ProgressContent = (props: ProgressContentProps) => {
  const { progressLevel, savedProgress } = useOrderContext();
  const { queryData, loading, error } = useNewOrderQueryData();

  const [createdDeliveryId, setCreatedDeliveryId] = useState<string>();

  const renderProgressContent = () => {
    if (loading) return <PageLoader text={t("loadingFormData")} />;

    if (error || !queryData.locations)
      return (
        <FallbackComponent
          middleIcon={<Close size={32} />}
          text={`${t("queryError")}. ${t("tryAgainLater")}`}
        />
      );

    switch (progressLevel) {
      case 1:
        return <GeneralInfoScreen />;
      case 2:
        return <DeliveryItemsScreen />;
      case 3:
        return <EnterTimesScreen />;
      case 4:
        return <DocumentItemsScreen />;
      case 5:
        return (
          <SummaryScreen
            setCreatedDeliveryId={(id: string) => setCreatedDeliveryId(id)}
          />
        );
      case 6:
        return <ConfirmationScreen createdDeliveryId={createdDeliveryId} />;
      default:
        return <></>;
    }
  };

  return (
    <>
      {renderProgressContent()}
      {/* Custom popup which prevents user from navigating away */}
      {/* We don't want it on or last screen */}
      {progressLevel !== 6 && (
        <LeaveNewOrderAlertDialog
          enableListener={!objectsHaveEqualValues(savedProgress, {})}
        />
      )}
    </>
  );
};

export default ProgressContent;
